<template>
  <div
    class="adsdsdfss"
    :style="{
      height: (height ? height : 260) + 'px',
      marginBottom: (mb ? mb : 16) + 'px',
    }"
  >
    <h2>{{ title }}</h2>
    <div class="sedewrtf" :style="{ background: bg ? bg : '#fff' }">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "height", "mb", "bg"],
  data() {
    return {};
  },
};
</script>
<style>
.adsdsdfss {
  width: 100%;
  background: #fff;
  padding: 15px;
}
.adsdsdfss h2 {
  font-size: 18px;
  height: 30px;
}
.adsdsdfss .sedewrtf {
  width: 100%;
  height: calc(100% - 30px);
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/lykanbanbox.vue